<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">

      <div v-if="props.row.nom" slot="nom" slot-scope="props">
        <span>{{ props.row.prenom }} {{ props.row.nom }}</span>
      </div>
      <div slot="is_bloquant" slot-scope="props">
        <span class="badge" :class="{'badge-success': props.row.is_bloquant, 'badge-danger': !props.row.is_bloquant}">
          <i class="fa" :class="{'fa-check': props.row.is_bloquant, 'fa-close': !props.row.is_bloquant}" />
        </span>
      </div>
      <div slot="status_id" slot-scope="props">
        <b :class="getStatusClass('bullet', status[props.row.status_id].libelle_technique)"><i :class="getStatusClass('icon', status[props.row.status_id].libelle_technique)"></i> {{ status[props.row.status_id].libelle_bo }}</b>
      </div>

      <div class="wrapper" slot="downloadPj" slot-scope="props">
        <a href="#" v-if="props.row.is_uploaded" @click.prevent="download(props.row.id,props.row.id_pp_dest_reglement,props.row.rs_pm_site, props.row.lib_cd_piece)">
          Visualiser
        </a>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../utils/auth'
import { downloadFile } from '../utils/fileHelper'

export default {
  name: "JustificatifTable",
  props: ["tableEntry","statusTab"],
  data() {
    let self = this;
    return {
      url: '',
      columns: [
        "lib_cd_piece",
        "rs_pm_site",
        "nom",
        "is_bloquant",
        "status_id",
        "downloadPj"
      ],
      options: {
        headings: {
          lib_cd_piece: "Libelle Piéce",
          rs_pm_site: "Etablissement",
          nom: "Bénéficiaire",
          is_bloquant: "Bloquant",
          status_id: "Statut",
          downloadPj: "#"
        },
        sortable: [],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 15, 20],
        texts: {
          filterPlaceholder: "N° Dossier"
        },
        orderBy: { column: "status_id" },
        requestFunction: function (data) {
            let benefId = self.tableEntry.benefId;
            self.url = '/espaceBeneficiaire/beneficiaires/justificatifs/' + benefId
            data["benefId"] = self.tableEntry.benefId;

            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
                params: data
            })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
        }
      }
    }
  },
  computed: {
    items: {
      get() {
        return this.tableEntry
      }
    },
    status: {
      get() {
        return this.statusTab
      }
    }
  },
  methods: {
    onLoaded(){
      this.$event.emit('getJustificatifs')
      // this.$store.commit("IS_LOADING", false);
    },
    download(justificatifId, nsi, etablissement, libelle) {
      let self = this
      let config = {
        justificatifId: justificatifId,
        nsi: nsi,
        etablissement: etablissement
      };
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .post("/espaceBeneficiaire/justificatifs/getfileextension", config)
        .then(response => {
          let extension = response.data.extension
          this.$axios
            .post("/espaceBeneficiaire/justificatifs/telechargement", config, { responseType: "arraybuffer" })
            .then(response => {
              this.$event.emit('refreshBeneficiaire');
              this.$store.commit("IS_LOADING", false)
              downloadFile(response, libelle, extension)
            })
            .catch(function(error) {
              console.log(error)
              self.$store.commit("IS_LOADING", false);
              let errorText = "Une erreur est survenue, si le problème persiste merci de faire un ticket au support"
              if (error.response && error.response.status === 404 && self !== undefined ) {
                errorText = "La pièce justificative demandée n'existe pas"
              }
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: errorText,
                showConfirmButton: false,
                timer: 5000
              })
            })
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false)
          let errorText ="Une erreur est survenue, si le problème persiste merci de faire un ticket au support"
          if (error.response && error.response.status === 404 && self !== undefined) {
            errorText = "La piéce justificative demandée n'existe pas"
          }
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: errorText,
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getStatusClass (type, libelleTechniqueBo) {
      const statusBulletClass = this.$store.getters.getStatusBulletClass;
      if (
        statusBulletClass &&
        statusBulletClass[libelleTechniqueBo] &&
        typeof statusBulletClass[libelleTechniqueBo][type] !== 'undefined'
      ) {
        return statusBulletClass[libelleTechniqueBo][type];
      }
      return '';
    },
  }
}
</script>
